var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComunicacion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.12 42.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daf0f2;}.cls-2{fill:#263980;}.cls-3{fill:#e5ab30;}.cls-4{fill:#c72318;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.84 1.69 13.25 1.69 1.95 21.26 13.25 40.82 35.84 40.82 47.14 21.26 35.84 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.85,42.51H12.27L0,21.26,12.27,0H36.85L49.12,21.26Zm-22.6-3.38h20.6L45.17,21.26,34.85,3.38H14.22L3.91,21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.59,8.44a21.91,21.91,0,0,1,2.9.59,10.22,10.22,0,0,1,7.23,7.41,6.54,6.54,0,0,1,.13.75A11.38,11.38,0,0,0,27,16.68c-.19-1-.46-1.18-1.45-1.18H18a1,1,0,1,0,0,2H24c-.86.66-1.69,1.31-2.54,1.93a.91.91,0,0,1-.49.08H18a1,1,0,0,0-1.1.88.49.49,0,0,0,0,.12,1,1,0,0,0,.93,1.06h2.08a8.53,8.53,0,0,0-.55,6.76,12,12,0,0,1-1.44-.44.85.85,0,0,0-1,.14,7.39,7.39,0,0,1-4.28,1.53,2.18,2.18,0,0,1-.78-.3,2.47,2.47,0,0,1,.38-.67,5.69,5.69,0,0,0,1.88-2.48.64.64,0,0,0-.1-.52,9.54,9.54,0,0,1-3.14-6.29,1.68,1.68,0,0,0-.09-.32v-.92c.1-.55.16-1.12.3-1.67A10.23,10.23,0,0,1,18.27,9a25.68,25.68,0,0,1,3-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,33.6a9.15,9.15,0,0,1-3.87-1.41.86.86,0,0,0-.59,0A8.85,8.85,0,0,1,23.94,31a6.51,6.51,0,0,1,0-11,8.81,8.81,0,0,1,11.72,1.51,7.65,7.65,0,0,1,1.41,3.33v1.26a7.4,7.4,0,0,1-1.16,3c-.33.43-.68.85-1,1.27a6.61,6.61,0,0,0,2.19,2.5v.69Zm-7-9h2.86a1,1,0,1,0,.07-2H26.14a1,1,0,0,0,0,2Zm0,4h2.86a1,1,0,0,0,0-2H26a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29,24.55H26.07a1,1,0,0,1,0-2h5.78a1.05,1.05,0,0,1,1.18.94.13.13,0,0,1,0,.06c0,.6-.48,1-1.2,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.94,28.56H26.08a1,1,0,0,1,0-2h5.77a1,1,0,0,1,0,2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicacion);
export default __webpack_public_path__ + "static/media/comunicacion.40430375ce1e8fe1d1188e1e923fc39b.svg";
export { ForwardRef as ReactComponent };